import React, { useState, useContext } from 'react';
import classnames from 'classnames';
import { Radio, RadioGroup } from '@letsdothis/lds/lib/Radio';

import DiscoveryContext from '../../../../../contexts/discoveryContext/contextV2';

const SportSelect = ({ update }) => {
  const {
    filters: {
      sport: { availableSports, id: sportId },
    },
  } = useContext(DiscoveryContext);

  const [selectedSport, setSelectedSport] = useState(`${sportId}`);

  const onToggle = (id) => {
    if (selectedSport === id) {
      setSelectedSport(null);
      update({
        sportId: -1,
      });
    } else {
      setSelectedSport(id);
      update({
        sportId: parseInt(id, 10),
      });
    }
  };

  if (!availableSports) return null;

  return (
    <RadioGroup
      value={selectedSport}
      onChange={(e) => onToggle(e.target.value)}
    >
      {availableSports.map(({ id, label }) => {
        return (
          <Radio key={id} value={`${id}`}>
            {label}
          </Radio>
        );
      })}
    </RadioGroup>
  );
};

export default SportSelect;
